import React from "react";
import { Link } from "react-router-dom";
import { cleanJoin } from "../../utils/stringUtil";
import "./DashboardItem.scss";

function DashboardItem({
  children,
  hasBorder = true,
  className,
  locationName,
  institutionName = "",
  label,
  labelAlignment = "centered",
  labelBulmaColor = "black",
  labelSize = 2,
  link,
  search,
  state,
  minHeight = "auto",
  contentPadding,
  ...rest
}) {
  return (
    <Link
      to={{
        pathname: link,
        search: search,
        state: state,
      }}
      {...rest}
    >
      <div
        className={cleanJoin(
          "dashboard-item",
          "card",
          hasBorder ? "dashboard-item-has-border" : ""
        )}
      >
        {locationName && <p className="has-border-bottom-grey-1 px-2 py-2 mb-0">{locationName}</p>}
        <div
          className={cleanJoin(
            "card-content",
            `${contentPadding}`,
            "has-text-centered is-flex is-flex-direction-column ",
            className
          )}
          style={{
            minHeight: minHeight,
            maxHeight: minHeight,
          }}
        >
          {label && (
            <div
              //style={{ fontSize: "1.2rem " }}
              className={cleanJoin(
                ` has-text-${labelAlignment}`,
                `is-size-${labelSize}`,
                `has-text-${labelBulmaColor}`,
                "overflow-y-hidden is-flex-grow-1"
              )}
            >
              {label}
            </div>
          )}

          <div
            className={cleanJoin(
              `has-text-${labelAlignment}`,
              " is-size-6 is-align-self-start is-flex is-flex-direction-row  is-justify-content-center"
            )}
          >
            {
              <div
                className={`${
                  labelAlignment !== "centered" && "is-flex-grow-1 is-flex is-align-items-center"
                }`}
              >
                {institutionName}
              </div>
            }
            {children}
          </div>
        </div>
      </div>
    </Link>
  );
}

export default DashboardItem;
